import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categorias" className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <p className="text-sm font-semibold text-accent-500 mb-3 tracking-wide uppercase">Explorar</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900">
            Categorias de Produtos
          </h2>
          <p className="mt-3 text-foreground-600 text-base md:text-lg max-w-xl">
            Navegue pelas nossas categorias e encontre os melhores produtos no CSSBuy Spreadsheet atualizado diariamente.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 transition-all duration-300 hover:ring-2 hover:ring-primary-200"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`CSSBuySpreadsheet ${cat.namePt} — ${cat.desc}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/25 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4">
                <h3 className="font-label text-sm font-bold text-foreground-900 whitespace-nowrap">
                  {cat.namePt}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed line-clamp-2">
                  {cat.desc}
                </p>
                <p className="text-xs font-medium text-primary-500 mt-2 flex items-center gap-1 whitespace-nowrap group-hover:gap-2 transition-all">
                  <span>Ver Itens</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}